import React from 'react';
import { Typography } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useTheme } from '../../contexts/ThemeContext';
import FileUpload from '../FileUpload';

const { Text } = Typography;

const ProjectBudgetUpload = ({ 
  project, 
  loading, 
  onUpload,
  isNewProject = false
}) => {
  const { theme } = useTheme();

  if (isNewProject) {
    return (
      <div style={{
        padding: 16,
        border: '1px solid #d9d9d9',
        borderRadius: 8,
        backgroundColor: '#fafafa',
        textAlign: 'center'
      }}>
        <EditOutlined style={{ fontSize: 24, color: '#8c8c8c', marginBottom: 8 }} />
        <div style={{ marginBottom: 8 }}>
          <Text style={{ fontSize: 13 }}>Salve o projeto primeiro para anexar planilha</Text>
        </div>
        <Text style={{ fontSize: 11, color: '#8c8c8c' }}>
          Excel (.xls, .xlsx) até 10MB
        </Text>
      </div>
    );
  }

  return (
    <FileUpload
      onFileUpload={onUpload}
      inputType="documents"
      baseUrl="project"
      preFilesIds={project.fileOrcamento ? [project.fileOrcamento] : []}
      entityId={project.id}
      entityType="project"
    />
  );
};

export default ProjectBudgetUpload; 